// Numeric outer API codes. Messages are translated display text, not routing keys.
export const APP_CODES = Object.freeze({
  SUCCESS: 0,
  VALIDATION_ERROR: 400,
  UNAUTHORIZED: 401,
  PASSWORD_CHANGE_TOKEN_INVALID: 410,
  ACCOUNT_ACCESS_DISABLED: 423,
  ONBOARDING_REQUIRED: 425,
  PASSWORD_CHANGE_REQUIRED: 428,
  RATE_LIMITED: 429,
});
export const PASSWORD_CHANGE_REASON = Object.freeze({
  ADMINISTRATOR_REQUIRED: 'administrator_required',
  EXPIRED: 'expired',
});
export const APP_ONBOARDING_STATUS = Object.freeze({
  PENDING_TERMS_ACCEPTANCE: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
});

export const APP_ONBOARDING_PATH = Object.freeze({
  TERMS: '/onboarding/terms',
  SETUP: '/onboarding/setup',
});
